/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateProjectClaimTokenResponse,
  DatabaseUpgradeStatusResponse,
  DiskAutoscaleConfig,
  DiskRequestBody,
  DiskUtilMetricsResponse,
  GetProjectAvailableRestoreVersionsResponse,
  NetworkBanResponse,
  NetworkBanResponseEnriched,
  NetworkRestrictionsPatchRequest,
  NetworkRestrictionsRequest,
  NetworkRestrictionsResponse,
  NetworkRestrictionsV2Response,
  OrganizationProjectsResponse,
  ProjectClaimTokenResponse,
  ProjectUpgradeEligibilityResponse,
  ProjectUpgradeInitiateResponse,
  RegionsInfo,
  RemoveNetworkBanRequest,
  UpgradeDatabaseBody,
  V1CreateProjectBody,
  V1GetAllProjectsForOrganizationParams,
  V1GetAvailableRegionsParams,
  V1GetPostgresUpgradeStatusParams,
  V1GetServicesHealthParams,
  V1ProjectRefResponse,
  V1ProjectResponse,
  V1ProjectWithDatabaseResponse,
  V1ServiceHealthResponse,
  V1UpdateProjectBody
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * Returns a list of all projects you've previously created.

Use `/v1/organizations/{slug}/projects` instead when possible to get more precise results and pagination support.
 * @summary List all projects
 */
export type v1ListAllProjectsResponse200 = {
  data: V1ProjectWithDatabaseResponse[]
  status: 200
}

export type v1ListAllProjectsResponseSuccess = (v1ListAllProjectsResponse200) & {
  headers: Headers;
};
;

export type v1ListAllProjectsResponse = (v1ListAllProjectsResponseSuccess)

export const getV1ListAllProjectsUrl = () => {


  

  return `/v1/projects`
}

export const v1ListAllProjects = async ( options?: RequestInit): Promise<v1ListAllProjectsResponse> => {
  
  return customFetch<v1ListAllProjectsResponse>(getV1ListAllProjectsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Create a project
 */
export type v1CreateAProjectResponse201 = {
  data: V1ProjectResponse
  status: 201
}

export type v1CreateAProjectResponseSuccess = (v1CreateAProjectResponse201) & {
  headers: Headers;
};
;

export type v1CreateAProjectResponse = (v1CreateAProjectResponseSuccess)

export const getV1CreateAProjectUrl = () => {


  

  return `/v1/projects`
}

export const v1CreateAProject = async (v1CreateProjectBody: V1CreateProjectBody, options?: RequestInit): Promise<v1CreateAProjectResponse> => {
  
  return customFetch<v1CreateAProjectResponse>(getV1CreateAProjectUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1CreateProjectBody,)
  }
);}
  

/**
 * @summary [Beta] Gets the list of available regions that can be used for a new project
 */
export type v1GetAvailableRegionsResponse200 = {
  data: RegionsInfo
  status: 200
}

export type v1GetAvailableRegionsResponseSuccess = (v1GetAvailableRegionsResponse200) & {
  headers: Headers;
};
;

export type v1GetAvailableRegionsResponse = (v1GetAvailableRegionsResponseSuccess)

export const getV1GetAvailableRegionsUrl = (params: V1GetAvailableRegionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/available-regions?${stringifiedParams}` : `/v1/projects/available-regions`
}

export const v1GetAvailableRegions = async (params: V1GetAvailableRegionsParams, options?: RequestInit): Promise<v1GetAvailableRegionsResponse> => {
  
  return customFetch<v1GetAvailableRegionsResponse>(getV1GetAvailableRegionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary [Beta] Gets project's network bans
 */
export type v1ListAllNetworkBansResponse201 = {
  data: NetworkBanResponse
  status: 201
}

export type v1ListAllNetworkBansResponse401 = {
  data: void
  status: 401
}

export type v1ListAllNetworkBansResponse403 = {
  data: void
  status: 403
}

export type v1ListAllNetworkBansResponse429 = {
  data: void
  status: 429
}

export type v1ListAllNetworkBansResponse500 = {
  data: void
  status: 500
}

export type v1ListAllNetworkBansResponseSuccess = (v1ListAllNetworkBansResponse201) & {
  headers: Headers;
};
export type v1ListAllNetworkBansResponseError = (v1ListAllNetworkBansResponse401 | v1ListAllNetworkBansResponse403 | v1ListAllNetworkBansResponse429 | v1ListAllNetworkBansResponse500) & {
  headers: Headers;
};

export type v1ListAllNetworkBansResponse = (v1ListAllNetworkBansResponseSuccess | v1ListAllNetworkBansResponseError)

export const getV1ListAllNetworkBansUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/network-bans/retrieve`
}

export const v1ListAllNetworkBans = async (ref: string, options?: RequestInit): Promise<v1ListAllNetworkBansResponse> => {
  
  return customFetch<v1ListAllNetworkBansResponse>(getV1ListAllNetworkBansUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * @summary [Beta] Gets project's network bans with additional information about which databases they affect
 */
export type v1ListAllNetworkBansEnrichedResponse201 = {
  data: NetworkBanResponseEnriched
  status: 201
}

export type v1ListAllNetworkBansEnrichedResponse401 = {
  data: void
  status: 401
}

export type v1ListAllNetworkBansEnrichedResponse403 = {
  data: void
  status: 403
}

export type v1ListAllNetworkBansEnrichedResponse429 = {
  data: void
  status: 429
}

export type v1ListAllNetworkBansEnrichedResponse500 = {
  data: void
  status: 500
}

export type v1ListAllNetworkBansEnrichedResponseSuccess = (v1ListAllNetworkBansEnrichedResponse201) & {
  headers: Headers;
};
export type v1ListAllNetworkBansEnrichedResponseError = (v1ListAllNetworkBansEnrichedResponse401 | v1ListAllNetworkBansEnrichedResponse403 | v1ListAllNetworkBansEnrichedResponse429 | v1ListAllNetworkBansEnrichedResponse500) & {
  headers: Headers;
};

export type v1ListAllNetworkBansEnrichedResponse = (v1ListAllNetworkBansEnrichedResponseSuccess | v1ListAllNetworkBansEnrichedResponseError)

export const getV1ListAllNetworkBansEnrichedUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/network-bans/retrieve/enriched`
}

export const v1ListAllNetworkBansEnriched = async (ref: string, options?: RequestInit): Promise<v1ListAllNetworkBansEnrichedResponse> => {
  
  return customFetch<v1ListAllNetworkBansEnrichedResponse>(getV1ListAllNetworkBansEnrichedUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * @summary [Beta] Remove network bans.
 */
export type v1DeleteNetworkBansResponse200 = {
  data: void
  status: 200
}

export type v1DeleteNetworkBansResponse401 = {
  data: void
  status: 401
}

export type v1DeleteNetworkBansResponse403 = {
  data: void
  status: 403
}

export type v1DeleteNetworkBansResponse429 = {
  data: void
  status: 429
}

export type v1DeleteNetworkBansResponse500 = {
  data: void
  status: 500
}

export type v1DeleteNetworkBansResponseSuccess = (v1DeleteNetworkBansResponse200) & {
  headers: Headers;
};
export type v1DeleteNetworkBansResponseError = (v1DeleteNetworkBansResponse401 | v1DeleteNetworkBansResponse403 | v1DeleteNetworkBansResponse429 | v1DeleteNetworkBansResponse500) & {
  headers: Headers;
};

export type v1DeleteNetworkBansResponse = (v1DeleteNetworkBansResponseSuccess | v1DeleteNetworkBansResponseError)

export const getV1DeleteNetworkBansUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/network-bans`
}

export const v1DeleteNetworkBans = async (ref: string,
    removeNetworkBanRequest: RemoveNetworkBanRequest, options?: RequestInit): Promise<v1DeleteNetworkBansResponse> => {
  
  return customFetch<v1DeleteNetworkBansResponse>(getV1DeleteNetworkBansUrl(ref),
  {      
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      removeNetworkBanRequest,)
  }
);}
  

/**
 * @summary [Beta] Gets project's network restrictions
 */
export type v1GetNetworkRestrictionsResponse200 = {
  data: NetworkRestrictionsResponse
  status: 200
}

export type v1GetNetworkRestrictionsResponse401 = {
  data: void
  status: 401
}

export type v1GetNetworkRestrictionsResponse403 = {
  data: void
  status: 403
}

export type v1GetNetworkRestrictionsResponse429 = {
  data: void
  status: 429
}

export type v1GetNetworkRestrictionsResponse500 = {
  data: void
  status: 500
}

export type v1GetNetworkRestrictionsResponseSuccess = (v1GetNetworkRestrictionsResponse200) & {
  headers: Headers;
};
export type v1GetNetworkRestrictionsResponseError = (v1GetNetworkRestrictionsResponse401 | v1GetNetworkRestrictionsResponse403 | v1GetNetworkRestrictionsResponse429 | v1GetNetworkRestrictionsResponse500) & {
  headers: Headers;
};

export type v1GetNetworkRestrictionsResponse = (v1GetNetworkRestrictionsResponseSuccess | v1GetNetworkRestrictionsResponseError)

export const getV1GetNetworkRestrictionsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/network-restrictions`
}

export const v1GetNetworkRestrictions = async (ref: string, options?: RequestInit): Promise<v1GetNetworkRestrictionsResponse> => {
  
  return customFetch<v1GetNetworkRestrictionsResponse>(getV1GetNetworkRestrictionsUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary [Alpha] Updates project's network restrictions by adding or removing CIDRs
 */
export type v1PatchNetworkRestrictionsResponse200 = {
  data: NetworkRestrictionsV2Response
  status: 200
}

export type v1PatchNetworkRestrictionsResponse401 = {
  data: void
  status: 401
}

export type v1PatchNetworkRestrictionsResponse403 = {
  data: void
  status: 403
}

export type v1PatchNetworkRestrictionsResponse429 = {
  data: void
  status: 429
}

export type v1PatchNetworkRestrictionsResponse500 = {
  data: void
  status: 500
}

export type v1PatchNetworkRestrictionsResponseSuccess = (v1PatchNetworkRestrictionsResponse200) & {
  headers: Headers;
};
export type v1PatchNetworkRestrictionsResponseError = (v1PatchNetworkRestrictionsResponse401 | v1PatchNetworkRestrictionsResponse403 | v1PatchNetworkRestrictionsResponse429 | v1PatchNetworkRestrictionsResponse500) & {
  headers: Headers;
};

export type v1PatchNetworkRestrictionsResponse = (v1PatchNetworkRestrictionsResponseSuccess | v1PatchNetworkRestrictionsResponseError)

export const getV1PatchNetworkRestrictionsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/network-restrictions`
}

export const v1PatchNetworkRestrictions = async (ref: string,
    networkRestrictionsPatchRequest: NetworkRestrictionsPatchRequest, options?: RequestInit): Promise<v1PatchNetworkRestrictionsResponse> => {
  
  return customFetch<v1PatchNetworkRestrictionsResponse>(getV1PatchNetworkRestrictionsUrl(ref),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      networkRestrictionsPatchRequest,)
  }
);}
  

/**
 * @summary [Beta] Updates project's network restrictions
 */
export type v1UpdateNetworkRestrictionsResponse201 = {
  data: NetworkRestrictionsResponse
  status: 201
}

export type v1UpdateNetworkRestrictionsResponse401 = {
  data: void
  status: 401
}

export type v1UpdateNetworkRestrictionsResponse403 = {
  data: void
  status: 403
}

export type v1UpdateNetworkRestrictionsResponse429 = {
  data: void
  status: 429
}

export type v1UpdateNetworkRestrictionsResponse500 = {
  data: void
  status: 500
}

export type v1UpdateNetworkRestrictionsResponseSuccess = (v1UpdateNetworkRestrictionsResponse201) & {
  headers: Headers;
};
export type v1UpdateNetworkRestrictionsResponseError = (v1UpdateNetworkRestrictionsResponse401 | v1UpdateNetworkRestrictionsResponse403 | v1UpdateNetworkRestrictionsResponse429 | v1UpdateNetworkRestrictionsResponse500) & {
  headers: Headers;
};

export type v1UpdateNetworkRestrictionsResponse = (v1UpdateNetworkRestrictionsResponseSuccess | v1UpdateNetworkRestrictionsResponseError)

export const getV1UpdateNetworkRestrictionsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/network-restrictions/apply`
}

export const v1UpdateNetworkRestrictions = async (ref: string,
    networkRestrictionsRequest: NetworkRestrictionsRequest, options?: RequestInit): Promise<v1UpdateNetworkRestrictionsResponse> => {
  
  return customFetch<v1UpdateNetworkRestrictionsResponse>(getV1UpdateNetworkRestrictionsUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      networkRestrictionsRequest,)
  }
);}
  

/**
 * @summary Gets a specific project that belongs to the authenticated user
 */
export type v1GetProjectResponse200 = {
  data: V1ProjectWithDatabaseResponse
  status: 200
}

export type v1GetProjectResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectResponse500 = {
  data: void
  status: 500
}

export type v1GetProjectResponseSuccess = (v1GetProjectResponse200) & {
  headers: Headers;
};
export type v1GetProjectResponseError = (v1GetProjectResponse401 | v1GetProjectResponse403 | v1GetProjectResponse429 | v1GetProjectResponse500) & {
  headers: Headers;
};

export type v1GetProjectResponse = (v1GetProjectResponseSuccess | v1GetProjectResponseError)

export const getV1GetProjectUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}`
}

export const v1GetProject = async (ref: string, options?: RequestInit): Promise<v1GetProjectResponse> => {
  
  return customFetch<v1GetProjectResponse>(getV1GetProjectUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Deletes the given project
 */
export type v1DeleteAProjectResponse200 = {
  data: V1ProjectRefResponse
  status: 200
}

export type v1DeleteAProjectResponse401 = {
  data: void
  status: 401
}

export type v1DeleteAProjectResponse403 = {
  data: void
  status: 403
}

export type v1DeleteAProjectResponse429 = {
  data: void
  status: 429
}

export type v1DeleteAProjectResponseSuccess = (v1DeleteAProjectResponse200) & {
  headers: Headers;
};
export type v1DeleteAProjectResponseError = (v1DeleteAProjectResponse401 | v1DeleteAProjectResponse403 | v1DeleteAProjectResponse429) & {
  headers: Headers;
};

export type v1DeleteAProjectResponse = (v1DeleteAProjectResponseSuccess | v1DeleteAProjectResponseError)

export const getV1DeleteAProjectUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}`
}

export const v1DeleteAProject = async (ref: string, options?: RequestInit): Promise<v1DeleteAProjectResponse> => {
  
  return customFetch<v1DeleteAProjectResponse>(getV1DeleteAProjectUrl(ref),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * @summary Updates the given project
 */
export type v1UpdateAProjectResponse200 = {
  data: V1ProjectRefResponse
  status: 200
}

export type v1UpdateAProjectResponse401 = {
  data: void
  status: 401
}

export type v1UpdateAProjectResponse403 = {
  data: void
  status: 403
}

export type v1UpdateAProjectResponse429 = {
  data: void
  status: 429
}

export type v1UpdateAProjectResponse500 = {
  data: void
  status: 500
}

export type v1UpdateAProjectResponseSuccess = (v1UpdateAProjectResponse200) & {
  headers: Headers;
};
export type v1UpdateAProjectResponseError = (v1UpdateAProjectResponse401 | v1UpdateAProjectResponse403 | v1UpdateAProjectResponse429 | v1UpdateAProjectResponse500) & {
  headers: Headers;
};

export type v1UpdateAProjectResponse = (v1UpdateAProjectResponseSuccess | v1UpdateAProjectResponseError)

export const getV1UpdateAProjectUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}`
}

export const v1UpdateAProject = async (ref: string,
    v1UpdateProjectBody: V1UpdateProjectBody, options?: RequestInit): Promise<v1UpdateAProjectResponse> => {
  
  return customFetch<v1UpdateAProjectResponse>(getV1UpdateAProjectUrl(ref),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1UpdateProjectBody,)
  }
);}
  

/**
 * @summary [Beta] Upgrades the project's Postgres version
 */
export type v1UpgradePostgresVersionResponse201 = {
  data: ProjectUpgradeInitiateResponse
  status: 201
}

export type v1UpgradePostgresVersionResponse401 = {
  data: void
  status: 401
}

export type v1UpgradePostgresVersionResponse403 = {
  data: void
  status: 403
}

export type v1UpgradePostgresVersionResponse429 = {
  data: void
  status: 429
}

export type v1UpgradePostgresVersionResponse500 = {
  data: void
  status: 500
}

export type v1UpgradePostgresVersionResponseSuccess = (v1UpgradePostgresVersionResponse201) & {
  headers: Headers;
};
export type v1UpgradePostgresVersionResponseError = (v1UpgradePostgresVersionResponse401 | v1UpgradePostgresVersionResponse403 | v1UpgradePostgresVersionResponse429 | v1UpgradePostgresVersionResponse500) & {
  headers: Headers;
};

export type v1UpgradePostgresVersionResponse = (v1UpgradePostgresVersionResponseSuccess | v1UpgradePostgresVersionResponseError)

export const getV1UpgradePostgresVersionUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/upgrade`
}

export const v1UpgradePostgresVersion = async (ref: string,
    upgradeDatabaseBody: UpgradeDatabaseBody, options?: RequestInit): Promise<v1UpgradePostgresVersionResponse> => {
  
  return customFetch<v1UpgradePostgresVersionResponse>(getV1UpgradePostgresVersionUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upgradeDatabaseBody,)
  }
);}
  

/**
 * @summary [Beta] Returns the project's eligibility for upgrades
 */
export type v1GetPostgresUpgradeEligibilityResponse200 = {
  data: ProjectUpgradeEligibilityResponse
  status: 200
}

export type v1GetPostgresUpgradeEligibilityResponse401 = {
  data: void
  status: 401
}

export type v1GetPostgresUpgradeEligibilityResponse403 = {
  data: void
  status: 403
}

export type v1GetPostgresUpgradeEligibilityResponse429 = {
  data: void
  status: 429
}

export type v1GetPostgresUpgradeEligibilityResponse500 = {
  data: void
  status: 500
}

export type v1GetPostgresUpgradeEligibilityResponseSuccess = (v1GetPostgresUpgradeEligibilityResponse200) & {
  headers: Headers;
};
export type v1GetPostgresUpgradeEligibilityResponseError = (v1GetPostgresUpgradeEligibilityResponse401 | v1GetPostgresUpgradeEligibilityResponse403 | v1GetPostgresUpgradeEligibilityResponse429 | v1GetPostgresUpgradeEligibilityResponse500) & {
  headers: Headers;
};

export type v1GetPostgresUpgradeEligibilityResponse = (v1GetPostgresUpgradeEligibilityResponseSuccess | v1GetPostgresUpgradeEligibilityResponseError)

export const getV1GetPostgresUpgradeEligibilityUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/upgrade/eligibility`
}

export const v1GetPostgresUpgradeEligibility = async (ref: string, options?: RequestInit): Promise<v1GetPostgresUpgradeEligibilityResponse> => {
  
  return customFetch<v1GetPostgresUpgradeEligibilityResponse>(getV1GetPostgresUpgradeEligibilityUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary [Beta] Gets the latest status of the project's upgrade
 */
export type v1GetPostgresUpgradeStatusResponse200 = {
  data: DatabaseUpgradeStatusResponse
  status: 200
}

export type v1GetPostgresUpgradeStatusResponse401 = {
  data: void
  status: 401
}

export type v1GetPostgresUpgradeStatusResponse403 = {
  data: void
  status: 403
}

export type v1GetPostgresUpgradeStatusResponse429 = {
  data: void
  status: 429
}

export type v1GetPostgresUpgradeStatusResponse500 = {
  data: void
  status: 500
}

export type v1GetPostgresUpgradeStatusResponseSuccess = (v1GetPostgresUpgradeStatusResponse200) & {
  headers: Headers;
};
export type v1GetPostgresUpgradeStatusResponseError = (v1GetPostgresUpgradeStatusResponse401 | v1GetPostgresUpgradeStatusResponse403 | v1GetPostgresUpgradeStatusResponse429 | v1GetPostgresUpgradeStatusResponse500) & {
  headers: Headers;
};

export type v1GetPostgresUpgradeStatusResponse = (v1GetPostgresUpgradeStatusResponseSuccess | v1GetPostgresUpgradeStatusResponseError)

export const getV1GetPostgresUpgradeStatusUrl = (ref: string,
    params?: V1GetPostgresUpgradeStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/upgrade/status?${stringifiedParams}` : `/v1/projects/${ref}/upgrade/status`
}

export const v1GetPostgresUpgradeStatus = async (ref: string,
    params?: V1GetPostgresUpgradeStatusParams, options?: RequestInit): Promise<v1GetPostgresUpgradeStatusResponse> => {
  
  return customFetch<v1GetPostgresUpgradeStatusResponse>(getV1GetPostgresUpgradeStatusUrl(ref,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Gets project's service health status
 */
export type v1GetServicesHealthResponse200 = {
  data: V1ServiceHealthResponse[]
  status: 200
}

export type v1GetServicesHealthResponse401 = {
  data: void
  status: 401
}

export type v1GetServicesHealthResponse403 = {
  data: void
  status: 403
}

export type v1GetServicesHealthResponse429 = {
  data: void
  status: 429
}

export type v1GetServicesHealthResponse500 = {
  data: void
  status: 500
}

export type v1GetServicesHealthResponseSuccess = (v1GetServicesHealthResponse200) & {
  headers: Headers;
};
export type v1GetServicesHealthResponseError = (v1GetServicesHealthResponse401 | v1GetServicesHealthResponse403 | v1GetServicesHealthResponse429 | v1GetServicesHealthResponse500) & {
  headers: Headers;
};

export type v1GetServicesHealthResponse = (v1GetServicesHealthResponseSuccess | v1GetServicesHealthResponseError)

export const getV1GetServicesHealthUrl = (ref: string,
    params: V1GetServicesHealthParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/health?${stringifiedParams}` : `/v1/projects/${ref}/health`
}

export const v1GetServicesHealth = async (ref: string,
    params: V1GetServicesHealthParams, options?: RequestInit): Promise<v1GetServicesHealthResponse> => {
  
  return customFetch<v1GetServicesHealthResponse>(getV1GetServicesHealthUrl(ref,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Pauses the given project
 */
export type v1PauseAProjectResponse200 = {
  data: void
  status: 200
}

export type v1PauseAProjectResponse401 = {
  data: void
  status: 401
}

export type v1PauseAProjectResponse403 = {
  data: void
  status: 403
}

export type v1PauseAProjectResponse429 = {
  data: void
  status: 429
}

export type v1PauseAProjectResponseSuccess = (v1PauseAProjectResponse200) & {
  headers: Headers;
};
export type v1PauseAProjectResponseError = (v1PauseAProjectResponse401 | v1PauseAProjectResponse403 | v1PauseAProjectResponse429) & {
  headers: Headers;
};

export type v1PauseAProjectResponse = (v1PauseAProjectResponseSuccess | v1PauseAProjectResponseError)

export const getV1PauseAProjectUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/pause`
}

export const v1PauseAProject = async (ref: string, options?: RequestInit): Promise<v1PauseAProjectResponse> => {
  
  return customFetch<v1PauseAProjectResponse>(getV1PauseAProjectUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * @summary Lists available restore versions for the given project
 */
export type v1ListAvailableRestoreVersionsResponse200 = {
  data: GetProjectAvailableRestoreVersionsResponse
  status: 200
}

export type v1ListAvailableRestoreVersionsResponse401 = {
  data: void
  status: 401
}

export type v1ListAvailableRestoreVersionsResponse403 = {
  data: void
  status: 403
}

export type v1ListAvailableRestoreVersionsResponse429 = {
  data: void
  status: 429
}

export type v1ListAvailableRestoreVersionsResponseSuccess = (v1ListAvailableRestoreVersionsResponse200) & {
  headers: Headers;
};
export type v1ListAvailableRestoreVersionsResponseError = (v1ListAvailableRestoreVersionsResponse401 | v1ListAvailableRestoreVersionsResponse403 | v1ListAvailableRestoreVersionsResponse429) & {
  headers: Headers;
};

export type v1ListAvailableRestoreVersionsResponse = (v1ListAvailableRestoreVersionsResponseSuccess | v1ListAvailableRestoreVersionsResponseError)

export const getV1ListAvailableRestoreVersionsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/restore`
}

export const v1ListAvailableRestoreVersions = async (ref: string, options?: RequestInit): Promise<v1ListAvailableRestoreVersionsResponse> => {
  
  return customFetch<v1ListAvailableRestoreVersionsResponse>(getV1ListAvailableRestoreVersionsUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Restores the given project
 */
export type v1RestoreAProjectResponse200 = {
  data: void
  status: 200
}

export type v1RestoreAProjectResponse401 = {
  data: void
  status: 401
}

export type v1RestoreAProjectResponse403 = {
  data: void
  status: 403
}

export type v1RestoreAProjectResponse429 = {
  data: void
  status: 429
}

export type v1RestoreAProjectResponseSuccess = (v1RestoreAProjectResponse200) & {
  headers: Headers;
};
export type v1RestoreAProjectResponseError = (v1RestoreAProjectResponse401 | v1RestoreAProjectResponse403 | v1RestoreAProjectResponse429) & {
  headers: Headers;
};

export type v1RestoreAProjectResponse = (v1RestoreAProjectResponseSuccess | v1RestoreAProjectResponseError)

export const getV1RestoreAProjectUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/restore`
}

export const v1RestoreAProject = async (ref: string, options?: RequestInit): Promise<v1RestoreAProjectResponse> => {
  
  return customFetch<v1RestoreAProjectResponse>(getV1RestoreAProjectUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * @summary Cancels the given project restoration
 */
export type v1CancelAProjectRestorationResponse200 = {
  data: void
  status: 200
}

export type v1CancelAProjectRestorationResponse401 = {
  data: void
  status: 401
}

export type v1CancelAProjectRestorationResponse403 = {
  data: void
  status: 403
}

export type v1CancelAProjectRestorationResponse429 = {
  data: void
  status: 429
}

export type v1CancelAProjectRestorationResponseSuccess = (v1CancelAProjectRestorationResponse200) & {
  headers: Headers;
};
export type v1CancelAProjectRestorationResponseError = (v1CancelAProjectRestorationResponse401 | v1CancelAProjectRestorationResponse403 | v1CancelAProjectRestorationResponse429) & {
  headers: Headers;
};

export type v1CancelAProjectRestorationResponse = (v1CancelAProjectRestorationResponseSuccess | v1CancelAProjectRestorationResponseError)

export const getV1CancelAProjectRestorationUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/restore/cancel`
}

export const v1CancelAProjectRestoration = async (ref: string, options?: RequestInit): Promise<v1CancelAProjectRestorationResponse> => {
  
  return customFetch<v1CancelAProjectRestorationResponse>(getV1CancelAProjectRestorationUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * @summary Gets project claim token
 */
export type v1GetProjectClaimTokenResponse200 = {
  data: ProjectClaimTokenResponse
  status: 200
}

export type v1GetProjectClaimTokenResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectClaimTokenResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectClaimTokenResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectClaimTokenResponseSuccess = (v1GetProjectClaimTokenResponse200) & {
  headers: Headers;
};
export type v1GetProjectClaimTokenResponseError = (v1GetProjectClaimTokenResponse401 | v1GetProjectClaimTokenResponse403 | v1GetProjectClaimTokenResponse429) & {
  headers: Headers;
};

export type v1GetProjectClaimTokenResponse = (v1GetProjectClaimTokenResponseSuccess | v1GetProjectClaimTokenResponseError)

export const getV1GetProjectClaimTokenUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/claim-token`
}

export const v1GetProjectClaimToken = async (ref: string, options?: RequestInit): Promise<v1GetProjectClaimTokenResponse> => {
  
  return customFetch<v1GetProjectClaimTokenResponse>(getV1GetProjectClaimTokenUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Creates project claim token
 */
export type v1CreateProjectClaimTokenResponse200 = {
  data: CreateProjectClaimTokenResponse
  status: 200
}

export type v1CreateProjectClaimTokenResponse401 = {
  data: void
  status: 401
}

export type v1CreateProjectClaimTokenResponse403 = {
  data: void
  status: 403
}

export type v1CreateProjectClaimTokenResponse429 = {
  data: void
  status: 429
}

export type v1CreateProjectClaimTokenResponseSuccess = (v1CreateProjectClaimTokenResponse200) & {
  headers: Headers;
};
export type v1CreateProjectClaimTokenResponseError = (v1CreateProjectClaimTokenResponse401 | v1CreateProjectClaimTokenResponse403 | v1CreateProjectClaimTokenResponse429) & {
  headers: Headers;
};

export type v1CreateProjectClaimTokenResponse = (v1CreateProjectClaimTokenResponseSuccess | v1CreateProjectClaimTokenResponseError)

export const getV1CreateProjectClaimTokenUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/claim-token`
}

export const v1CreateProjectClaimToken = async (ref: string, options?: RequestInit): Promise<v1CreateProjectClaimTokenResponse> => {
  
  return customFetch<v1CreateProjectClaimTokenResponse>(getV1CreateProjectClaimTokenUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * @summary Revokes project claim token
 */
export type v1DeleteProjectClaimTokenResponse204 = {
  data: void
  status: 204
}

export type v1DeleteProjectClaimTokenResponse401 = {
  data: void
  status: 401
}

export type v1DeleteProjectClaimTokenResponse403 = {
  data: void
  status: 403
}

export type v1DeleteProjectClaimTokenResponse429 = {
  data: void
  status: 429
}

export type v1DeleteProjectClaimTokenResponseSuccess = (v1DeleteProjectClaimTokenResponse204) & {
  headers: Headers;
};
export type v1DeleteProjectClaimTokenResponseError = (v1DeleteProjectClaimTokenResponse401 | v1DeleteProjectClaimTokenResponse403 | v1DeleteProjectClaimTokenResponse429) & {
  headers: Headers;
};

export type v1DeleteProjectClaimTokenResponse = (v1DeleteProjectClaimTokenResponseSuccess | v1DeleteProjectClaimTokenResponseError)

export const getV1DeleteProjectClaimTokenUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/claim-token`
}

export const v1DeleteProjectClaimToken = async (ref: string, options?: RequestInit): Promise<v1DeleteProjectClaimTokenResponse> => {
  
  return customFetch<v1DeleteProjectClaimTokenResponse>(getV1DeleteProjectClaimTokenUrl(ref),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * @summary Get disk utilization
 */
export type v1GetDiskUtilizationResponse200 = {
  data: DiskUtilMetricsResponse
  status: 200
}

export type v1GetDiskUtilizationResponse401 = {
  data: void
  status: 401
}

export type v1GetDiskUtilizationResponse403 = {
  data: void
  status: 403
}

export type v1GetDiskUtilizationResponse429 = {
  data: void
  status: 429
}

export type v1GetDiskUtilizationResponse500 = {
  data: void
  status: 500
}

export type v1GetDiskUtilizationResponseSuccess = (v1GetDiskUtilizationResponse200) & {
  headers: Headers;
};
export type v1GetDiskUtilizationResponseError = (v1GetDiskUtilizationResponse401 | v1GetDiskUtilizationResponse403 | v1GetDiskUtilizationResponse429 | v1GetDiskUtilizationResponse500) & {
  headers: Headers;
};

export type v1GetDiskUtilizationResponse = (v1GetDiskUtilizationResponseSuccess | v1GetDiskUtilizationResponseError)

export const getV1GetDiskUtilizationUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/disk/util`
}

export const v1GetDiskUtilization = async (ref: string, options?: RequestInit): Promise<v1GetDiskUtilizationResponse> => {
  
  return customFetch<v1GetDiskUtilizationResponse>(getV1GetDiskUtilizationUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Modify database disk
 */
export type v1ModifyDatabaseDiskResponse201 = {
  data: void
  status: 201
}

export type v1ModifyDatabaseDiskResponse401 = {
  data: void
  status: 401
}

export type v1ModifyDatabaseDiskResponse403 = {
  data: void
  status: 403
}

export type v1ModifyDatabaseDiskResponse429 = {
  data: void
  status: 429
}

export type v1ModifyDatabaseDiskResponse500 = {
  data: void
  status: 500
}

export type v1ModifyDatabaseDiskResponseSuccess = (v1ModifyDatabaseDiskResponse201) & {
  headers: Headers;
};
export type v1ModifyDatabaseDiskResponseError = (v1ModifyDatabaseDiskResponse401 | v1ModifyDatabaseDiskResponse403 | v1ModifyDatabaseDiskResponse429 | v1ModifyDatabaseDiskResponse500) & {
  headers: Headers;
};

export type v1ModifyDatabaseDiskResponse = (v1ModifyDatabaseDiskResponseSuccess | v1ModifyDatabaseDiskResponseError)

export const getV1ModifyDatabaseDiskUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/disk`
}

export const v1ModifyDatabaseDisk = async (ref: string,
    diskRequestBody: DiskRequestBody, options?: RequestInit): Promise<v1ModifyDatabaseDiskResponse> => {
  
  return customFetch<v1ModifyDatabaseDiskResponse>(getV1ModifyDatabaseDiskUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      diskRequestBody,)
  }
);}
  

/**
 * @summary Gets project disk autoscale config
 */
export type v1GetProjectDiskAutoscaleConfigResponse200 = {
  data: DiskAutoscaleConfig
  status: 200
}

export type v1GetProjectDiskAutoscaleConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectDiskAutoscaleConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectDiskAutoscaleConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectDiskAutoscaleConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetProjectDiskAutoscaleConfigResponseSuccess = (v1GetProjectDiskAutoscaleConfigResponse200) & {
  headers: Headers;
};
export type v1GetProjectDiskAutoscaleConfigResponseError = (v1GetProjectDiskAutoscaleConfigResponse401 | v1GetProjectDiskAutoscaleConfigResponse403 | v1GetProjectDiskAutoscaleConfigResponse429 | v1GetProjectDiskAutoscaleConfigResponse500) & {
  headers: Headers;
};

export type v1GetProjectDiskAutoscaleConfigResponse = (v1GetProjectDiskAutoscaleConfigResponseSuccess | v1GetProjectDiskAutoscaleConfigResponseError)

export const getV1GetProjectDiskAutoscaleConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/disk/autoscale`
}

export const v1GetProjectDiskAutoscaleConfig = async (ref: string, options?: RequestInit): Promise<v1GetProjectDiskAutoscaleConfigResponse> => {
  
  return customFetch<v1GetProjectDiskAutoscaleConfigResponse>(getV1GetProjectDiskAutoscaleConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Returns a paginated list of projects for the specified organization.

This endpoint uses offset-based pagination. Use the `offset` parameter to skip a number of projects and the `limit` parameter to control the number of projects returned per page.
 * @summary Gets all projects for the given organization
 */
export type v1GetAllProjectsForOrganizationResponse200 = {
  data: OrganizationProjectsResponse
  status: 200
}

export type v1GetAllProjectsForOrganizationResponse500 = {
  data: void
  status: 500
}

export type v1GetAllProjectsForOrganizationResponseSuccess = (v1GetAllProjectsForOrganizationResponse200) & {
  headers: Headers;
};
export type v1GetAllProjectsForOrganizationResponseError = (v1GetAllProjectsForOrganizationResponse500) & {
  headers: Headers;
};

export type v1GetAllProjectsForOrganizationResponse = (v1GetAllProjectsForOrganizationResponseSuccess | v1GetAllProjectsForOrganizationResponseError)

export const getV1GetAllProjectsForOrganizationUrl = (slug: string,
    params?: V1GetAllProjectsForOrganizationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/organizations/${slug}/projects?${stringifiedParams}` : `/v1/organizations/${slug}/projects`
}

export const v1GetAllProjectsForOrganization = async (slug: string,
    params?: V1GetAllProjectsForOrganizationParams, options?: RequestInit): Promise<v1GetAllProjectsForOrganizationResponse> => {
  
  return customFetch<v1GetAllProjectsForOrganizationResponse>(getV1GetAllProjectsForOrganizationUrl(slug,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

